<template>
  <div>
    <Modal v-model="isShow" :loading="loading" width="650" :mask-closable="false">
      <h3 slot="header" class="modal-header">ZO列表</h3>
      <Table :columns="columns" :data="data">
      </Table>
      <Button class="mt20" type="primary" @click.stop="addZo" v-p="{api:'projectConfig/addProjectZO'}">添加</Button>
      <div slot="footer">
      </div>
      <add-z-o :n="addN" :projectFid="projectFid" :projectName="projectName" @addsuccess="getZoList"></add-z-o>
      <update-z-o :n="updateN" :formDataOri="updateFormData" @editsuccess="getZoList"></update-z-o>
    </Modal>
  </div>
</template>
<script>
  import AddZO from './AddZO'
  import {projectConfigZOList, deleteProjectZO} from "../../../../api/projectConfig";
  import UpdateZO from './UpdateZO'

  export default {
    name: "ZoList",
    components: {
      AddZO,
      UpdateZO
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectFid: {
        type: String,
        default: null
      },
      projectName: {
        type: String,
        default: null
      }
    },
    watch: {
      n() {
        this.data=[]
        this.getZoList()
        this.isShow = true
      },
      // projectFid(value) {
      //   if (!value) {
      //     return
      //   }
      //   this.getZoList()
      // }

    },
    data() {
      return {
        updateFormData: {},
        updateN: 0,
        addN: 0,
        loading: true,
        isShow: false,
        data: [],
        columns: [
          {
            title: "操作",
            key: "keyA",
            align: "center",
            render: (h, params) => {
              return h('div', {}, [
                h('a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'projectConfig/editProjectZO'
                      }
                    }
                  ],
                  on: {
                    click: () => {
                      this.updateFormData = params.row
                      this.updateN++
                    }
                  }
                }, '修改'),
                h('a', {
                  style: {
                    marginLeft: '10px'
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'projectConfig/deleteProjectZO'
                      }
                    }
                  ],
                  on: {
                    click: () => {
                      this.deleteItem(params.row)
                    }
                  }
                }, '删除')
              ])
            }
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center"
          },
          {
            title: "管家姓名 ",
            key: "pzoName",
            align: "center"
          },
          {
            title: "是否显示 ",
            key: "pzoStatus",
            align: "center",
            render:(h,params)=>{
              return h('span',{},params.row['pzoStatus']===1?'显示':'不显示')
            }
          },

        ]
      }
    },
    methods: {
      deleteItem(item) {

        this.$Modal.confirm({
          content: '<p>确认删除本条ZO记录？</p>',
          onOk: () => {
            let params={
              fid:item.fid

            }
            deleteProjectZO(params).then(res=>{
              this.$Message.success('ZO记录删除成功')
              this.getZoList()

            }).catch(error=>{})
          }
        })

      },
      addZo() {
        this.addN++
      },
      getZoList() {
        if (!this.projectFid) {
          return
        }
        let params = {
          projectFid: this.projectFid
        }
        projectConfigZOList(params).then(res => {
          this.data = res.data
        }).catch(error=>{})
      }

    },
    // created() {
    //   // this.getZoList()
    // }
  }
</script>

<style scoped>

</style>
